import { PlessViewUtilsSub } from './pless-view-utils-sub.service';
import { PlessResponderSub } from './pless-responder-sub.service';
import { CommonSettingModel } from 'src/app/kymw/kymw10/kymw1002/vo/common-setting.model';

/**
 * 環境設定管理共通部品
 */
export class CommonSetting extends PlessResponderSub { // TODO: shuto add 確認: この継承は意味ないのでは？

  private static commonSettings: CommonSettingModel[];

  /**
   * 設定値取得
   * @param keyName キー名
   */
  static getVal(keyName: string): string {
    const item = this.commonSettings.find(item => PlessViewUtilsSub.trim(item.KeyName) === keyName);
    return !!item ? item.KeyValue : '';
  }

  /**
   * 説明取得
   * @param keyName キー名
   */
  static getExp(keyName: string): string {
    const item = this.commonSettings.find(item => PlessViewUtilsSub.trim(item.KeyName) === keyName);
    return !!item ? item.Explain : '';
  }

  /**
   * 初期処理
   */
  static init(data: CommonSettingModel[]) {
    // 環境設定管理のデータをセット
    this.commonSettings = data;
  }

}
